import { create } from "zustand";
import { createTickerSlice, TickerSlice } from "@/stores/ticker.slice";

const useTickerStore = create<TickerSlice>()((...a) => ({
  ...createTickerSlice(...a),
}));

const tickerStore = useTickerStore;
export { useTickerStore, tickerStore };
